module.exports = __webpack_public_path__ + "img/logo.9608ff18.svg";